// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { ArrowLeft } from "lucide-react";

// const UpdateCommunication = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [email, setEmail] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const apiAddress = process.env.REACT_APP_SECRET;

//   useEffect(() => {
//     fetchEmail();
//   }, [id]);

//   const fetchEmail = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(
//         `${apiAddress}/api/SubSection/GetEmailById/${id}`
//       );
//       const data = await res.json();
//       setEmail(data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) return <p>Loading...</p>;

//   return (
//     <div style={{ padding: "40px" }}>
//       <button onClick={() => navigate(-1)}>
//         <ArrowLeft /> Back
//       </button>

//       <h2>{email?.sub}</h2>

//       <p>
//         <strong>Status:</strong> {email?.statuss}
//       </p>

//       <p>
//         <strong>Date:</strong>{" "}
//         {new Date(email?.creationDate).toLocaleString()}
//       </p>

//       <div
//         style={{
//           background: "#f8f9fa",
//           padding: "20px",
//           borderRadius: "8px",
//           marginTop: "20px",
//         }}
//         dangerouslySetInnerHTML={{ __html: email?.body }}
//       />
//     </div>
//   );
// };

// export default UpdateCommunication;
import React, { useEffect, useRef, useState } from "react";
import {
  Bold,
  Italic,
  Underline,
  List,
  ListOrdered,
  Link as LinkIcon,
  Image as ImageIcon,
  Trash2,
  Send,
  Save,
  Eye,
  Palette,
  ALargeSmall,
  AlignRight,
  AlignJustify,
  AlignCenter,
  AlignLeft,
  File as FileIcon
} from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";

import "../components/RichTextEditor.css";
import { toast } from "react-toastify";
import axios from "axios";

export default function UpdateCommunication() {
  const editorRef = useRef<HTMLDivElement>(null);
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
const [loading, setLoading] = useState(false);

  // Images
  const [images, setImages] = useState<{ src: string; name: string }[]>([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const [email, setEmail] = useState(null);



  useEffect(() => {
    fetchEmail();
  }, [id]);

  const fetchEmail = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${apiAddress}/api/SubSection/GetEmailById/${id}`
      );
      const data = await res.json();
      setEmail(data);

      // Set default values for inputs when editing
      setSubject(data?.sub || "");
      setContent(data?.body || "");

      // Populate editor content if available
      if (editorRef.current && data?.body) {
        editorRef.current.innerHTML = data.body;
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  // Documents
  const [documents, setDocuments] = useState<{ name: string; url: string }[]>([]);

  // --- Link popup ---
  const [showLinkPopup, setShowLinkPopup] = useState(false);
  const [linkValue, setLinkValue] = useState("");
  const [linkTargetBlank, setLinkTargetBlank] = useState(true);
  const savedRange = useRef<Range | null>(null);

  // --- Color popup ---
  const [showColorPopup, setShowColorPopup] = useState(false);
  const [colorValue, setColorValue] = useState("#ff0000");

  // --- Font popup ---
  const [showFontPopup, setShowFontPopup] = useState(false);
  const [fontSizeValue, setFontSizeValue] = useState("16");
  const [fontFamilyValue, setFontFamilyValue] = useState("Arial");

  // --- Formatting ---
  const format = (command: string, value: any = null) => {
    document.execCommand(command, false, value);
    setContent(editorRef.current?.innerHTML || "");
  };

  const handleInput = () => {
    setContent(editorRef.current?.innerHTML || "");
  };

  // --- Handle Paste (for screenshots/images) ---
  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    const items = e.clipboardData?.items;
    if (!items) return;

    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        e.preventDefault();
        const blob = items[i].getAsFile();
        if (!blob) continue;

        const reader = new FileReader();
        reader.onload = (event: ProgressEvent<FileReader>) => {
          if (event.target?.result) {
            const imgId = `img-${Date.now()}-${Math.random()}`;
            const imgWrapper = `
              <span class="pasted-image-wrapper" style="display: inline-block; position: relative; margin: 8px 4px;">
                <img src="${event.target.result}" style="max-width: 150px; max-height: 150px; display: block; border: 1px solid #ddd; border-radius: 4px;" data-img-id="${imgId}" />
                <button class="delete-pasted-img" data-img-id="${imgId}" style="position: absolute; top: -8px; right: -8px; background: #ff4444; color: white; border: none; border-radius: 50%; width: 24px; height: 24px; cursor: pointer; font-size: 16px; line-height: 1; box-shadow: 0 2px 4px rgba(0,0,0,0.2); font-weight: bold;">×</button>
              </span>
            `;
            document.execCommand("insertHTML", false, imgWrapper);
            setContent(editorRef.current?.innerHTML || "");

            // Attach delete handler
            setTimeout(() => {
              const deleteBtn = editorRef.current?.querySelector(
                `button[data-img-id="${imgId}"]`
              );
              if (deleteBtn) {
                deleteBtn.addEventListener("click", (evt) => {
                  evt.preventDefault();
                  evt.stopPropagation();
                  const wrapper = (evt.target as HTMLElement).closest(".pasted-image-wrapper");
                  wrapper?.remove();
                  setContent(editorRef.current?.innerHTML || "");
                });
              }
            }, 100);
          }
        };
        reader.readAsDataURL(blob);
        break;
      }
    }
  };

  // --- Insert Link ---
  const openLinkPopup = () => {
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      savedRange.current = sel.getRangeAt(0).cloneRange();
    }
    setLinkValue("");
    setLinkTargetBlank(true);
    setShowLinkPopup(true);
  };

  const insertLink = () => {
    if (!linkValue) {
      setShowLinkPopup(false);
      return;
    }

    if (savedRange.current) {
      const sel = window.getSelection();
      if (sel) {
        sel.removeAllRanges();
        sel.addRange(savedRange.current);
      }
    }

    document.execCommand("createLink", false, linkValue);

    setShowLinkPopup(false);
    setContent(editorRef.current?.innerHTML || "");
    savedRange.current = null;
  };

  // --- Apply Color ---
  const openColorPopup = () => {
    setShowColorPopup(true);
  };
  const applyColor = () => {
    format("foreColor", colorValue);
    setShowColorPopup(false);
  };

  // --- Font ---
  const openFontPopup = () => {
    // Get current font settings if text is selected
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0 && !sel.isCollapsed) {
      const range = sel.getRangeAt(0);
      const parentElement = range.commonAncestorContainer.parentElement;
      
      if (parentElement) {
        const computedStyle = window.getComputedStyle(parentElement);
        const currentSize = parseInt(computedStyle.fontSize);
        const currentFamily = computedStyle.fontFamily.replace(/['"]/g, '').split(',')[0];
        
        setFontSizeValue(currentSize.toString());
        setFontFamilyValue(currentFamily);
      }
    }
    setShowFontPopup(true);
  };

  const applyFontSize = (size: string) => {
    setFontSizeValue(size);
    editorRef.current?.focus();
    
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0 && !sel.isCollapsed) {
      // Text is selected - apply to selection only
      document.execCommand("fontSize", false, "7");
      
      setTimeout(() => {
        if (editorRef.current) {
          const fontElements = editorRef.current.querySelectorAll('font[size="7"]');
          fontElements.forEach((el) => {
            el.removeAttribute("size");
            (el as HTMLElement).style.fontSize = size + "px";
          });
          setContent(editorRef.current?.innerHTML || "");
        }
      }, 0);
    } else {
      // No selection - apply for next typing
      document.execCommand("fontSize", false, "7");
      
      setTimeout(() => {
        if (editorRef.current) {
          const fontElements = editorRef.current.querySelectorAll('font[size="7"]');
          fontElements.forEach((el) => {
            el.removeAttribute("size");
            (el as HTMLElement).style.fontSize = size + "px";
          });
          setContent(editorRef.current?.innerHTML || "");
        }
      }, 0);
    }
  };

  const applyFontFamily = (family: string) => {
    setFontFamilyValue(family);
    editorRef.current?.focus();
    format("fontName", family);
  };

  const closeFontPopup = () => {
    setShowFontPopup(false);
    editorRef.current?.focus();
  };

  // --- Image Upload ---
const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (event: ProgressEvent<FileReader>) => {
    if (event.target?.result) {
      const imgId = `uploaded-img-${Date.now()}`;
      
      // Focus editor first
      editorRef.current?.focus();
      
      const imgTag = `
        <span class="uploaded-image-wrapper" style="display: inline-block; position: relative; margin: 8px 4px;">
          <img src="${event.target.result}" alt="uploaded" style="max-width: 150px; max-height: 150px; display: block; border: 1px solid #ddd; border-radius: 4px;" data-img-id="${imgId}" />
          <button class="delete-uploaded-img" data-img-id="${imgId}" style="position: absolute; top: -8px; right: -8px; background: #ff4444; color: white; border: none; border-radius: 50%; width: 24px; height: 24px; cursor: pointer; font-size: 16px; line-height: 1; box-shadow: 0 2px 4px rgba(0,0,0,0.2); font-weight: bold;">×</button>
        </span>
      `;
      
      // Insert at the end of editor content
      if (editorRef.current) {
        editorRef.current.innerHTML += imgTag;
        
        // Update content state
        setContent(editorRef.current.innerHTML);
        
        // Attach delete handler
        setTimeout(() => {
          const deleteBtn = editorRef.current?.querySelector(
            `button[data-img-id="${imgId}"]`
          );
          if (deleteBtn) {
            deleteBtn.addEventListener("click", (evt) => {
              evt.preventDefault();
              evt.stopPropagation();
              const wrapper = (evt.target as HTMLElement).closest(".uploaded-image-wrapper");
              wrapper?.remove();
              setContent(editorRef.current?.innerHTML || "");
            });
          }
        }, 100);
      }

      // Add to images state for tracking
      setImages((prev) => [
        ...prev,
        { src: event.target.result as string, name: file.name },
      ]);
    }
  };

  reader.readAsDataURL(file);
  e.target.value = "";
};

  const removeImage = (index: number) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

// Delegated click handler for editor delete buttons
useEffect(() => {
  const editor = editorRef.current;
  if (!editor) return;

  const onClick = (evt: MouseEvent) => {
    const target = evt.target as HTMLElement;
    const delBtn = target.closest('button.delete-pasted-img, button.delete-uploaded-img, button.delete-inline-doc') as HTMLElement | null;
    if (!delBtn) return;

    evt.preventDefault();
    evt.stopPropagation();

    const wrapper = delBtn.closest('.pasted-image-wrapper, .uploaded-image-wrapper, .inline-document-wrapper') as HTMLElement | null;
    if (!wrapper) return;

    // Remove associated image from state if any
    const imgEl = wrapper.querySelector('img') as HTMLImageElement | null;
    if (imgEl) {
      const src = imgEl.src;
      setImages((prev) => prev.filter((i) => i.src !== src));
    }

    // Remove associated document from state if any
    const docName = wrapper.getAttribute('data-doc-name');
    if (docName) {
      setDocuments((prev) => prev.filter((d) => d.name !== docName));
    }

    wrapper.remove();
    setContent(editorRef.current?.innerHTML || '');
  };

  editor.addEventListener('click', onClick);
  return () => editor.removeEventListener('click', onClick);
}, [editorRef]);


// --- DOCUMENT UPLOAD (PDF, DOCX, etc.) ---
const handleDocumentUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (event: ProgressEvent<FileReader>) => {
    if (event.target?.result && editorRef.current) {
      const docId = `doc-${Date.now()}`;
      
      // Create document element to insert in editor
      const docWrapper = document.createElement('div');
      docWrapper.className = 'inline-document-wrapper';
      docWrapper.style.cssText = 'display: inline-block; margin: 8px 4px; padding: 8px 12px; background: #f0f0f0; border: 1px solid #ddd; border-radius: 4px; position: relative;';
      docWrapper.setAttribute('data-doc-id', docId);
      docWrapper.setAttribute('data-doc-name', file.name);
      docWrapper.setAttribute('data-doc-base64', event.target.result as string);
      
      const icon = document.createElement('span');
      icon.innerHTML = '📎';
      icon.style.marginRight = '8px';
      
      const fileName = document.createElement('span');
      fileName.textContent = file.name;
      fileName.style.color = '#0066cc';
      
      const deleteBtn = document.createElement('button');
      deleteBtn.textContent = '×';
      deleteBtn.className = 'delete-inline-doc';
      deleteBtn.style.cssText = 'margin-left: 8px; background: #ff4444; color: white; border: none; border-radius: 50%; width: 20px; height: 20px; cursor: pointer; font-size: 14px; line-height: 1;';
      
      deleteBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        docWrapper.remove();
        setContent(editorRef.current?.innerHTML || "");
        // Remove from documents state
        setDocuments(prev => prev.filter(d => d.name !== file.name));
      });
      
      docWrapper.appendChild(icon);
      docWrapper.appendChild(fileName);
      docWrapper.appendChild(deleteBtn);
      
      // Append to editor
      editorRef.current.appendChild(docWrapper);
      editorRef.current.appendChild(document.createElement('br')); // Add line break
      
      // Update content state
      setContent(editorRef.current.innerHTML);
      
      // Add to documents state with base64
      setDocuments((prev) => [
        ...prev, 
        { 
          name: file.name, 
          url: event.target.result as string // Store base64 directly
        }
      ]);
    }
  };

  reader.readAsDataURL(file);
  e.target.value = "";
};

  const removeDocument = (index: number) => {
    setDocuments((prev) => prev.filter((_, i) => i !== index ));
  };
const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));

const apiAddress = process.env.REACT_APP_SECRET; 


const updateContentToBackend = async () => {
  if (!subject) {
    toast.error("Subject is required");
    return;
  }

  try {
    setLoading(true);

    let finalBody = editorRef.current?.innerHTML || "";
    
    console.log("=== Before Processing ===");
    console.log(finalBody);

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = finalBody;
    
    const docWrappers = tempDiv.querySelectorAll('.inline-document-wrapper');
    docWrappers.forEach((wrapper) => {
      const docName = wrapper.getAttribute('data-doc-name');
      const docBase64 = wrapper.getAttribute('data-doc-base64');
      
      if (docName && docBase64) {
        const link = document.createElement('a');
        link.href = docBase64;
        link.download = docName;
        link.textContent = `📎 ${docName}`;
        link.style.cssText = 'color: #0066cc; text-decoration: underline; margin: 0 8px;';
        
        wrapper.replaceWith(link);
      }
    });
    
    finalBody = tempDiv.innerHTML;

    console.log("=== After Processing ===");
    console.log(finalBody);

    const payload = {
      id: id, // ✅ ADD THIS - from useParams
      restaurantId: Restauranttoken?.id || "",
      sub: subject, // ✅ Changed from "subject" to "sub" to match backend
      body: finalBody,
      statuss: 2, // ✅ Changed from "status" to "statuss" to match backend
      creationId: "user-001",
    };

    const response = await axios.put(
      `${apiAddress}/api/SubSection/UpdateEmail`,
      payload
    );

    console.log("Response:", response.data);
    toast.success(response.data?.message || "Content Updated Successfully");

    // Navigate back or refresh after successful update
    navigate(-1); // or fetchEmail() to reload data

  } catch (error: any) {
    console.error("Error updating content:", error);
    toast.error(error.response?.data?.message || "Failed to update content");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="editor-wrapper">
      <div className="editor-container">

        <h2 className="editor-title">Update Message</h2>

        <input
          type="text"
          placeholder="Subject"
          className="subject-input"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />

        {/* Toolbar */}
        <div className="toolbar">
          <button onClick={() => format("bold")}><Bold size={18} /></button>
          <button onClick={() => format("italic")}><Italic size={18} /></button>
          <button onClick={() => format("underline")}><Underline size={18} /></button>
          <button onClick={() => format("insertUnorderedList")}><List size={18} /></button>
          <button onClick={() => format("insertOrderedList")}><ListOrdered size={18} /></button>

          <button onClick={openLinkPopup}><LinkIcon size={18} /></button>
          <button onClick={openColorPopup}><Palette size={18} /></button>
          <button onClick={openFontPopup}><ALargeSmall size={18} /></button>

          <button onClick={() => format("justifyLeft")}><AlignLeft size={18} /></button>
          <button onClick={() => format("justifyCenter")}><AlignCenter size={18} /></button>
          <button onClick={() => format("justifyRight")}><AlignRight size={18} /></button>
          <button onClick={() => format("justifyFull")}><AlignJustify size={18} /></button>

          {/* Image Upload */}
          <label className="image-upload">
            <ImageIcon size={18} />
            <input type="file" accept="image/*" onChange={handleImageUpload} />
          </label>

          {/* Document Upload */}
          <label className="image-upload" title="Upload Document">
            <FileIcon size={18} />
            <input
              type="file"
              accept=".pdf,.doc,.docx,.txt,.ppt,.pptx"
              onChange={handleDocumentUpload}
            />
          </label>
        </div>

        {/* Editor */}
        <div
          ref={editorRef}
          contentEditable
          className="editor-area"
          onInput={handleInput}
          onPaste={handlePaste}
          suppressContentEditableWarning
        ></div>

        {/* Image Preview */}
        {images.length > 0 && (
          <div className="image-preview-box">
            {images.map((img, i) => (
              <div key={i} className="image-preview">
                <img src={img.src} />
                <button onClick={() => removeImage(i)}><Trash2 size={14} /></button>
                <p>{img.name}</p>
              </div>
            ))}
          </div>
        )}

        {/* Document Preview */}
        {documents.length > 0 && (
          <div className="document-preview-box">
            {documents.map((doc, i) => (
              <div key={i} className="document-preview">
                <FileIcon size={18} />
                <a href={doc.url} target="_blank">{doc.name}</a>
                <button onClick={() => removeDocument(i)}>
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Actions */}
        <div className="actions">
     <button className="send-btn" onClick={updateContentToBackend}>
  <Send size={16} /> Update
</button>

          <button className="save-btn"><Save size={16} /> Save Draft</button>
          <button className="cancel-btn"><Trash2 size={16} /> Cancel</button>
        </div>

        {/* Preview */}
        {/* <div className="preview-section">
          <h3><Eye size={18} /> Preview</h3>

          <p><strong>Subject:</strong> {subject || "No subject"}</p>

          <div
            className="preview-content"
            dangerouslySetInnerHTML={{
              __html: content || "<em>Start typing...</em>",
            }}
          />
        </div> */}

        {/* LINK MODAL */}
        {showLinkPopup && (
          <div className="editor-modal-backdrop">
            <div className="editor-modal">
              <h3>Insert Link</h3>
              <input
                type="url"
                value={linkValue}
                onChange={(e) => setLinkValue(e.target.value)}
                className="editor-modal-input"
              />
              <label>
                <input
                  type="checkbox"
                  checked={linkTargetBlank}
                  onChange={(e) => setLinkTargetBlank(e.target.checked)}
                />
                Open in new tab
              </label>
              <div className="editor-modal-actions">
                <button onClick={() => setShowLinkPopup(false)}>Cancel</button>
                <button onClick={insertLink}>Insert</button>
              </div>
            </div>
          </div>
        )}

        {/* COLOR MODAL */}
        {showColorPopup && (
          <div className="editor-modal-backdrop">
            <div className="editor-modal">
              <h3>Choose Text Color</h3>
              <input
                type="color"
                value={colorValue}
                onChange={(e) => setColorValue(e.target.value)}
              />
              <div className="editor-modal-actions">
                <button onClick={() => setShowColorPopup(false)}>Cancel</button>
                <button onClick={applyColor}>Apply</button>
              </div>
            </div>
          </div>
        )}

        {/* FONT MODAL */}
        {showFontPopup && (
          <div className="editor-modal-backdrop" onClick={closeFontPopup}>
            <div className="editor-modal" onClick={(e) => e.stopPropagation()}>
              <h3>Font Settings</h3>

              <label>Font Family</label>
              <select
                value={fontFamilyValue}
                onChange={(e) => applyFontFamily(e.target.value)}
                className="editor-modal-input"
              >
                <option value="Arial">Arial</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Courier New">Courier New</option>
                <option value="Georgia">Georgia</option>
                <option value="Verdana">Verdana</option>
                <option value="Poppins">Poppins</option>
                <option value="Roboto">Roboto</option>
                <option value="Open Sans">Open Sans</option>
                <option value="Montserrat">Montserrat</option>
                <option value="Lato">Lato</option>
                <option value="Ubuntu">Ubuntu</option>
                <option value="Nunito">Nunito</option>
              </select>

              <label>Font Size</label>
              <select
                value={fontSizeValue}
                onChange={(e) => applyFontSize(e.target.value)}
                className="editor-modal-input"
              >
                {[8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 44, 48, 54, 60, 66, 72, 80, 88, 96].map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>

              <div className="editor-modal-actions">
                <button onClick={closeFontPopup}>Done</button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
